import { site } from "@/content/site";

export function Logo({ dark = false }: { dark?: boolean }) {
  return (
    <a
      href="#top"
      className="inline-flex items-center gap-2.5"
      aria-label={`${site.brand}, zur Startseite`}
    >
      <span className="grid size-9 place-items-center rounded-xl bg-brand text-white">
        <svg
          viewBox="0 0 24 24"
          className="size-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="m5 6 6 6-6 6" />
          <path d="m12 6 6 6-6 6" />
        </svg>
      </span>
      <span
        className={`font-display text-xl font-bold tracking-tight ${
          dark ? "text-white" : "text-ink"
        }`}
      >
        {site.brand}
      </span>
    </a>
  );
}
